import React from 'react';

const BoxAmenities = ({ amenities }) => {
    if (!amenities || amenities.length === 0) {
        return <p>No amenities available</p>;
    }

    
    const chunkSize = 5;
    const groupedAmenities = [];
    for (let i = 0; i < amenities.length; i += chunkSize) {
        groupedAmenities.push(amenities.slice(i, i + chunkSize));
    }

    return (
        <div>
            <div className="wg-property box-amenities">
                <div className="wg-title text-11 fw-6 text-color-heading">
                    Amenities And Features
                </div>
                <div className="wrap-feature">
                    {groupedAmenities.map((group, index) => (
                        <div className="box-feature" key={index}>
                            <ul>
                                {group.map((amenity, i) => (
                                    <li className="feature-item" key={i}>{amenity}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BoxAmenities;
